import request from './request.js'

export default{
    //查询电脑名是否存在黑名单中
    judgeExistsComputer(params) {
      // 拼接参数：computerName 电脑名
      return request({
        url: '/BlackList/ExistsSyncComputerName' + params,
        method: 'get',
      });
    },
    //添加黑名单（电脑名）
    addBlackComputer(params) {
      return request({
        url: '/BlackList/AddBlackListComputerName'+ params,
        method: 'post',
      });
    },
    //删除黑名单（电脑名）
    deleteBlackComputer(params) {
      return request({
        url: '/BlackList/RemoveBlackListComputerName'+ params,
        method: 'post',
      });
    },
    //查询所有黑名单（电脑名）
    getBlackAll(){
      return request({
        url: '/BlackList/GetAllSyncComputeName',
        method: 'get',
      });
    }
}
